import { startCase } from 'lodash';
import {
    ItemFieldTemplate,
    ItemFieldTemplateContent,
    ItemFieldTemplateRow,
} from 'store/item-field-templates/itemFieldTemplate';

const DECLARATION_TYPE = 'UK Export B1';

const FIELD_LABELS: Record<string, string> = {
    additionalInformation: 'Additional Information',
    additionalDocument: 'Additional Document',
};

const isFilled = (value: unknown) => (Array.isArray(value) ? value.length > 0 : value != null && value !== '');

const getFieldsIncluded = (template: ItemFieldTemplateContent) =>
    Object.entries(template)
        .filter(([, value]) => isFilled(value))
        .map(([key]) => FIELD_LABELS[key] ?? startCase(key));

const getCodes = ({ additionalInformation = [], additionalDocument = [] }: ItemFieldTemplateContent) => {
    const statementCodes = additionalInformation.map((information) => information.statementCode);
    const documentCodes = additionalDocument.map(({ categoryCode, typeCode }) =>
        categoryCode && typeCode ? `${categoryCode}${typeCode}` : undefined
    );

    const codes = [...statementCodes, ...documentCodes].filter(Boolean) as string[];
    return Array.from(new Set(codes));
};

const toItemFieldTemplateRow = ({ id, name, template }: ItemFieldTemplate): ItemFieldTemplateRow => ({
    id,
    name,
    declarationType: DECLARATION_TYPE,
    fieldsIncluded: getFieldsIncluded(template),
    codes: getCodes(template),
});

export default toItemFieldTemplateRow;
